<template>
  <div class="modal-card" ref="element">

    <header class="modal-card-head">
      <p class="modal-card-title">{{isSO ? 'Special offers archive' : 'Menus archive'}}</p>
    </header>

    <section class="modal-card-body" >
        <div v-if="noResources">The archive is empty.</div>
        <main class="grid">
          <div v-for="(im,id) in libImages" :key="id">
            <img :src="im.url" @click="selectImage(im.url, im.name, im.file)" :class="im.url === selectedUrl ? 'active' : ''" style="cursor:pointer" alt="">
            <span class="caption" :style="im.url === selectedUrl ? 'font-weight: bold' : ''">{{im.name}}</span>
          </div>
        </main>
     </section>
     <footer v-if="!noResources" class="modal-card-foot" style="background-color:white;border-radius:0px">
         <p><b>Selected image: </b>{{selectedName}}</p>
  </footer>

    <footer class="modal-card-foot">
        <div v-if="!noResources">
      <b-button type="is-info" @click="uploadPicture()">Select</b-button>
      <b-button type="is-light" @click="closeModal()">Cancel</b-button>
      </div>
      <div v-else>
        <b-button type="is-light" @click="closeModal()">Close</b-button>
      </div>
    </footer>

  </div>
</template>

<script>

export default {
  name: 'MenusBin',
  props: ['isSO', 'propParent'],
  data: () => {
    return {
      libImages: [],
      loadingComponent: null,
      selectedUrl: '',
      selectedName: '',
      selectedFile: null,
      noResources: false
    }
  },
  mounted: function () {
    this.loadingComponent = this.$buefy.loading.open()
    var menuDirsRef = null
    if (!this.isSO) {
      if (this.$store.state.menusArchive === null) {
        this.loadingComponent.close()
        this.noResources = true
      } else {
        if (!this.getNotMigrated().includes(this.$store.state.uid)) {
          menuDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/MenusArchive/')
        } else {
          menuDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/MenusArchive/')
        }
        menuDirsRef.listAll().then((dir) => {
          dir.items.forEach(fileRef => {
            this.initialCount++
            fileRef.getDownloadURL().then((url) => {
              const xhr = new XMLHttpRequest()
              xhr.responseType = 'blob'
              xhr.onload = (event) => {
                const blob = xhr.response
                var file = new File([blob], fileRef.name, {type: blob.type})
                this.libImages.push({ 'name': fileRef.name, 'url': url, 'file': file, 'size': blob.size })
                this.loadingComponent.close()
              }
              xhr.open('GET', url)
              xhr.send()
            }).catch((error) => {
              this.globalLogger('error', error)
            })
          })
        })
      }
    } else {
      if (this.$store.state.specialOffersArchive === null) {
        this.loadingComponent.close()
        this.noResources = true
      } else {
        if (!this.getNotMigrated().includes(this.$store.state.uid)) {
          menuDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.workspaceId + '/SpecialOffersArchive/')
        } else {
          menuDirsRef = this.$store.state.storage.ref('/clients/' + this.$store.state.username + '/SpecialOffersArchive/')
        }
        menuDirsRef.listAll().then((dir) => {
          dir.items.forEach(fileRef => {
            this.initialCount++
            fileRef.getDownloadURL().then((url) => {
              const xhr = new XMLHttpRequest()
              xhr.responseType = 'blob'
              xhr.onload = (event) => {
                const blob = xhr.response
                var file = new File([blob], fileRef.name, {type: blob.type})
                this.libImages.push({ 'name': fileRef.name, 'url': url, 'file': file, 'size': blob.size })
                this.loadingComponent.close()
              }
              xhr.open('GET', url)
              xhr.send()
            }).catch((error) => {
              this.globalLogger('error', error)
            })
          })
        })
      }
    }
  },
  methods: {
    closeModal () {
      this.$parent.close()
    },
    selectImage (url, name, file) {
      this.selectedUrl = url
      this.selectedName = name
      this.selectedFile = file
    },
    uploadPicture () {
      this.propParent(this.selectedFile)
      this.$parent.close()
    }
  }
}
</script>

<style scoped>
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  grid-gap:20px;
  align-items: center;
  }
.grid img {
  box-shadow: 2px 2px 6px 0px  rgba(0,0,0,0.3);
  max-width: 100%;
}
.active {
  border: 3.2px solid #3e8ed0;
}
.caption {
    display: block;
    font-size: 10pt;
    text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/components/menu/items/MenusBin.vue